import { cn } from '../../../lib/utils';
import React, { useState, useEffect, useRef } from 'react'
import { X } from 'lucide-react'
import DatePicker from '../../DatePicker'
import SearchBar from '../../SearchBar'

// Layout wrapper for date range + search
export default function Toolbar({
  searchValue,
  onSearchChange,
  planSearchValue,
  onPlanSearchChange,
  dateRange,
  onDateRangeChange,
  searchRef,
  isDark = false,
  groupingCategoryFilter = null,
}) {
  const handleDateRangeChange = (start, end) => {
    onDateRangeChange?.(start, end)
  }

  const [planInputValue, setPlanInputValue] = useState(planSearchValue || '');
  const planTimeoutRef = useRef(null);

  useEffect(() => {
    setPlanInputValue(planSearchValue || '');
  }, [planSearchValue]);

  const handlePlanChange = (e) => {
    const val = e.target.value;
    setPlanInputValue(val);
    if (planTimeoutRef.current) clearTimeout(planTimeoutRef.current);
    if (val === '' || val.length > 2) {
      planTimeoutRef.current = setTimeout(() => {
        onPlanSearchChange?.(val);
      }, 1000);
    }
  };

  const handlePlanClear = () => {
    setPlanInputValue('');
    if (planTimeoutRef.current) clearTimeout(planTimeoutRef.current);
    onPlanSearchChange?.('');
  };

  return (
    <div className={cn("flex flex-col sm:flex-row items-stretch sm:items-center gap-[12px] sm:gap-[16px]")}>
      <DatePicker
        intiStartDate={dateRange.startDate}
        intiEndDate={dateRange.endDate}
        onDateChange={handleDateRangeChange}
        isDark={isDark}
      />

      {groupingCategoryFilter}

      <SearchBar
        value={searchValue}
        placeholder="Search other columns"
        onSearch={onSearchChange}
        ref={searchRef}
        isDark={isDark}
        containerClassName="sm:w-[340px]"
      />

      <div className="relative">
        <div
          className={cn(
            "h-[40px] rounded-[12px] px-[16px] py-[6px] flex items-center gap-[10px] w-full sm:w-[340px] transition-colors duration-200 border-solid border-[1px]",
            isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
          )}
        >
          <div
            className="w-[16px] h-[16px] shrink-0"
            style={{
              backgroundColor: isDark ? '#b3b3b3' : '#072837',
              WebkitMaskImage: "url('/assets/icons/search.svg')",
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskImage: "url('/assets/icons/search.svg')",
              maskRepeat: 'no-repeat',
              maskSize: 'contain',
              maskPosition: 'center',
            }}
            aria-hidden="true"
          />
          <input
            type="text"
            className={cn(
              "flex-1 outline-none border-0 font-normal text-[16px] bg-transparent w-full transition-colors duration-200",
              isDark ? 'text-[#b3b3b3] placeholder:text-[#8c8c8c]' : 'text-[#072837] placeholder:text-[#686868]'
            )}
            placeholder="Search by plan no."
            value={planInputValue}
            onChange={handlePlanChange}
          />
          {planInputValue && (
            <button
              type="button"
              onClick={handlePlanClear}
              className="shrink-0 flex items-center justify-center cursor-pointer bg-transparent border-0 p-0"
              aria-label="Clear plan search"
            >
              <X size={16} color={isDark ? '#b3b3b3' : '#686868'} />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
